import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { CouncilWebSessionService } from '../services/council-web-session.service';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

export const councilWebSessionInterceptor:HttpInterceptorFn=(request,next)=>{
  const session=inject(CouncilWebSessionService);
  return next(request.url.startsWith(environment.baseUrl)&&session.activityHeader()?request.clone({setHeaders:{'X-Web-Activity':'1'}}):request).pipe(catchError(error=>{if(error.status===401)session.endIfCouncil();return throwError(()=>error);}));
};
